import toJS from 'shared/components/toJS';
import withAsyncId from 'shared/components/withAsyncId';
import { openCancelConfirmModal } from 'redux/domain/App';
import { ACCEPTABLE_CODES } from 'redux/domain/FindCustomer/constants';
import { connect } from 'react-redux';
import { reduxForm, SubmissionError } from 'redux-form';
import {
	closeModal,
	findCustomer,
	openModal,
	setModalMessage,
	verifyZipCode,
} from 'redux/domain/FindCustomer';
import FindCustomer from './FindCustomer';
import withRouter from 'shared/utils/WithRouter';

// TO DO : check if there's a pending verifyZipCode request. If there is, cancel it.
// See ApplicationEntry/index for details
export const asyncValidate = async (values, dispatch, props) => {
	const errors = {};
	const zipResponse = await verifyZipCode(props.asyncId, values.zipCode)(dispatch);
	if (zipResponse.data.valid === false) {
		errors.zipCode = 'Invalid Postal Code';
	}
	if (Object.keys(errors).length > 0) {
		throw errors;
	}
};

export const mapStateToProps = state => ({
	modalMessage: state.findCustomer.get('modalMessage'),
	modalOpen: state.findCustomer.get('modalOpen'),
	settings: state.cache.get('settings'),
});

const mapDispatchToProps = {
	closeModal,
	openCancelConfirmModal,
};

export const onSubmit = async (values, dispatch, props) => {
	const errors = {};
	const findCustomerResponse = await findCustomer(props.asyncId, values)(dispatch);
	if (!ACCEPTABLE_CODES.includes(findCustomerResponse.data.responseData.findCustomerResult)) {
		// eslint-disable-next-line no-underscore-dangle
		errors._error = findCustomerResponse.data.message;
	}
	if (Object.keys(errors).length > 0) {
		throw new SubmissionError(errors);
	}
	return findCustomerResponse.data.responseData;
};

export const onSubmitFail = (errors, dispatch) => {
	// eslint-disable-next-line no-underscore-dangle
	const formError = errors._error;
	if (formError) {
		dispatch(setModalMessage(formError));
		dispatch(openModal());
	}
};

export const onSubmitSuccess = (result, dispatch, props) => {
	props.change('state', result.state);
	props.change('city', result.city);
	props.change('sessionId', result.sessionId);
	props.change('customerId', result.customerId);
	props.router.navigate('/ApplicationEntry');
};

// generate a route-aware container component
const FindCustomerContainer = withAsyncId(
	withRouter(
		reduxForm({
			asyncValidate,
			asyncBlurFields: ['zipCode'],
			form: 'FindCustomer',
			destroyOnUnmount: false, // keep form data after component unmounts
			forceUnregisterOnUnmount: true,
			onSubmit,
			onSubmitFail,
			onSubmitSuccess,
		})(connect(mapStateToProps, mapDispatchToProps)(toJS(FindCustomer))),
	),
);

export default FindCustomerContainer;
